export default "__VITE_ASSET__2UpmdyQO__"